import { Box, MenuItem } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { getWhere, parentTreeItem } from "library/tree/index.mjs"
import { SCHEDULE } from "library/constants.mjs"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { folderTypes } from "routes/schedule/folder-manager/add-folder"

export function ShareLinkSearchResult({ props, item }) {
    const locationBreadcrumb = getWhere(item[parentTreeItem])

    return (
        <MenuItem {...props} data-cy="share-link-search-result" sx={{ alignItems: "flex-start" }}>
            <Iconify
                sx={{ display: "inline-block", mr: 1, mt: 0.25, color: "primary.main", flexShrink: 0 }}
                icon={icon()}
            />
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <TruncatedTypography variant="body2">{itemLabel()}</TruncatedTypography>
                <TruncatedTypography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                    {locationBreadcrumb}
                </TruncatedTypography>
            </Box>
        </MenuItem>
    )

    function itemLabel() {
        return item.code ? `${item.code} - ${item.label}` : item.label
    }

    function icon() {
        if (item.data?.type === "facility") return "mdi:office-building"
        if (item.type === SCHEDULE) return "mdi:file-document-outline"
        if (item.data?.subType === "space") return "fluent:conference-room-24-filled"
        return folderTypes[item.data?.subType]?.icon ?? "material-symbols:folder-rounded"
    }
}
